import type { ChangeEvent, FC } from 'react';
import cx from 'classnames';
import { useStore } from 'zustand';

import { Textarea } from '@motorway/mw-highway-code/src/components/Textarea';

import { DynamicPlaceholder } from 'Features/SellerCommunications/components/DynamicPlaceholder';
import { EmailBodyStore, emailEditorService, MAX_EMAIL_BODY_LENGTH } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import { triggerSellerMessagingBodyInputClickedEvent } from 'Services/analytics/events';

import styles from './EmailForm.module.scss';

export const EmailBodySection: FC = () => {
	const { body, bodyError } = useStore(EmailBodyStore);

	const handleBodyChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		emailEditorService.onBodyChange(e.target.value);
	};

	const isLimitExceeded = !!(bodyError && bodyError === T.translate('createEmail.validationErrors.bodyMaxLength'));

	return (
		<section className={styles.emailBody}>
			<div className={styles.bodyContainer}>
				<DynamicPlaceholder
					className={cx(styles.bodyPlaceholder, bodyError && styles.bodyPlaceholderError)}
					text={`${T.translate('createEmail.emailBody.dynamicPlaceholder')}`}
				/>
				<Textarea
					fullHeight
					fullWidth
					showLabel
					formProps={{
						input: {
							onChange: handleBodyChange,
							onFocus: triggerSellerMessagingBodyInputClickedEvent,
							value: body,
						},
					}}
					id="emailBody"
					intent={bodyError ? 'error' : undefined}
					label={T.translate('createEmail.emailBody.label')}
					placeholder={`${T.translate('createEmail.emailBody.placeholder')}`}
					validationMessage={bodyError}
				/>
			</div>
			<span className={cx(styles.bodyCharacterCount, isLimitExceeded && styles.bodyCharacterCountError)}>
				{T.translate('createEmail.emailBody.charactersCount', {
					count: body.length,
					max: MAX_EMAIL_BODY_LENGTH,
				})}
			</span>
		</section>
	);
};
